
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCow } from "@fortawesome/free-solid-svg-icons";
import { Card, CardHeader, CardContent } from "@/components/ui/card";

interface AnimalStat {
  species: string;
  count: number;
}

interface AnimalStatsProps {
  animalsBySpecies: AnimalStat[] | undefined;
}

const AnimalStats: React.FC<AnimalStatsProps> = ({ animalsBySpecies }) => {
  return (
    <Card className="mb-4 w-full mt-4">
      <CardHeader className="bg-white pb-2">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-800">Total Animals</h2>
          <FontAwesomeIcon icon={faCow} className="h-6 w-6 text-[hsl(215,95%,32%)]" />
        </div>
      </CardHeader>
      
      <CardContent className="pt-4">
        {animalsBySpecies && animalsBySpecies.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 w-full preserve-grid">
            {animalsBySpecies.map((animal, index) => (
              <div 
                key={index} 
                className="text-center p-3 rounded-md bg-gray-50 flex flex-col items-center justify-center min-w-[100px] preserve-flex"
              >
                <p className="text-xl font-bold text-[hsl(215,95%,32%)]">{animal.count}</p>
                <p className="text-sm text-gray-600">{animal.species}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-6 text-center">
            <p className="text-gray-500">No animals added yet</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default AnimalStats;
